(function ($, window) {
    $(document).ready(init);

    /**
     * Handle menu
     */
    function init() {
        var $menuOpen = $('.header__button');
        var $menuClose = $('.menu__button');
        var $menu = $('.menu');
        var $navigation = $('.header__navigation');

        var closeMenu = function () {
            $navigation.removeClass('header__navigation--hidden');
            $menu.addClass('menu--hidden');
        };

        function openMenu() {
            $navigation.addClass('header__navigation--hidden');
            $menu.removeClass('menu--hidden');
        }

        $menuOpen.click(function () {
            openMenu();
        });

        $menuClose.click(function () {
            closeMenu();
        });

        $(document).mouseup(function (e) {
            if (!$menu.is(e.target) && $menu.has(e.target).length === 0 && !$menuOpen.is(e.target)) {
                closeMenu();
            }
        });

        //Unfold the menu
        $('.menu__html li a').on('click', function (e) {
            var $target = $(e.target);

            // open menu if there are any sub-menu items
            if ($target.siblings('ul').length > 0) {
                e.preventDefault();

                // get menu item
                var $menu_element = $target.closest('li');

                // close other menu items
                $menu_element.siblings().removeClass('active');
                $menu_element.toggleClass('active');
            }
        });
    }


})(jQuery, window);